'use strict';
require('./warnAboutDeprecatedCJSRequire.js')('createBrowserHistory');
module.exports = require('./index.js').createBrowserHistory;



/*****************
 ** WEBPACK FOOTER
 ** ./~/react-router-dom/~/history/createBrowserHistory.js
 ** module id = 1896
 ** module chunks = 0
 **/